import {
  BOT_MONITOR_CHECK_ERRORS,
  BOT_MONITOR_STATUSES,
} from "../constants/botMonitor"
import {
  BotMonitorCheckError,
  BotMonitorResponse,
  BotMonitorStatus,
} from "../interfaces/botMonitor"

const isObject = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === "object" && !Array.isArray(value)
const isUTCDate = (value: unknown): value is string => {
  if (
    typeof value !== "string" ||
    !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.test(value)
  )
    return false
  const date = new Date(value)
  return (
    Number.isFinite(date.getTime()) &&
    date.toISOString().slice(0, 19) === value.slice(0, 19)
  )
}

/** Structural checks only: dates/outcomes never determine the saved bot status. */
export const isBotMonitorResponse = (
  value: unknown,
): value is BotMonitorResponse => {
  if (
    !isObject(value) ||
    !Array.isArray(value.items) ||
    !Number.isSafeInteger(value.total) ||
    (value.total as number) < 0
  )
    return false
  const ids = new Set<number>()
  return value.items.every((item) => {
    if (
      !isObject(item) ||
      !Number.isSafeInteger(item.botId) ||
      typeof item.username !== "string"
    )
      return false
    if (!BOT_MONITOR_STATUSES.includes(item.status as BotMonitorStatus))
      return false
    if (
      !["createdAt", "blockedAt", "lastCheckAt", "lastSuccessfulCheckAt"].every(
        (key) => item[key] === null || isUTCDate(item[key]),
      )
    )
      return false
    if (
      item.lastCheckOutcome !== null &&
      item.lastCheckOutcome !== "ok" &&
      item.lastCheckOutcome !== "error"
    )
      return false
    if (
      item.lastCheckError !== null &&
      !BOT_MONITOR_CHECK_ERRORS.includes(
        item.lastCheckError as BotMonitorCheckError,
      )
    )
      return false
    if (item.lastCheckOutcome === "ok" && item.lastCheckError !== null)
      return false
    const id = item.botId as number
    if (ids.has(id)) return false
    ids.add(id)
    return true
  })
}

export const BOT_MONITOR_INVALID_RESPONSE = "BOT_MONITOR_INVALID_RESPONSE"
